import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FileCopyIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "file-copy",
  "FileCopyIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M5.99984 2.66663H10.276L12.6665 5.05691V10.6666H5.99984V2.66663ZM7.33317 3.99996V9.33329H11.3332V5.99972H9.33317V3.99996H7.33317Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/><path d="M4.99984 6.66663H3.6665L3.6665 13H9.99984V11.6666H4.99984V6.66663Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default FileCopyIcon;
